import script from "./no-account.vue?vue&type=script&setup=true&lang=js"
export * from "./no-account.vue?vue&type=script&setup=true&lang=js"

import "./no-account.vue?vue&type=style&index=0&id=39635740&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39635740"]])

export default __exports__